import { Vue, Component, Prop, Emit, Watch} from 'vue-property-decorator';

import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import EditableTableColumn from '@/../bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';

@Component({
  name: 'PopUpRetornoEsocial',
  components: {
    TkForm,
    EditableTable,
  },
})
class PopUpRetornoEsocial extends Vue {
  @Prop({ default: false }) private readonly value!: boolean;
  @Prop({ default: () => ({}) }) private readonly retorno!: any;

  private internalValue = false;

  @Emit('input')
  private emitInput(value: boolean) {}

  private get grid() {
    return {
      columns: [
        {
          value: 'MSG',
          text: 'Mensagem',
        },
        {
          value: 'NRCHAVE',
          text: 'Chave',
        },
        {
          value: 'NMEVENTO',
          text: 'Evento',
        },
        {
          value: 'TYPE',
          text: 'Tipo',
        },
      ],
      loading: false,
      tableReadonly: true,
      reloadOnCreation: true,
      rows: [],
      toolbarActions: [
        {
          name: 'reload',
          label: 'Atualizar',
          icon: 'mdi-refresh',
          onClick: this.reloadGrid,
        },
      ],
    };
  }

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    
    this.internalValue = this.value;
    //this.onShowPopup();
  }

  @Watch('retorno', { immediate: true, deep: true })
  private onRetornoChange(newVal: any[]) {
    this.reloadGrid();
  }
  // #endregion

  private closeDialog(): void {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  // #region [ LIFECYCLE ]
  private created() {
    this.internalValue = this.value;
  }
  // #endregion

   // [ METHODS ]
  // [ METHODS ]
  @Watch('isVisible', { immediate: true, deep: true })
  private isVisibleOnChange(newValue: boolean) {
    if (newValue) {
      this.onShowPopup();
    }
  }

  private onShowPopup() {
    this.reloadGrid();
  }

  private async reloadGrid() {
   
    const grid = this.grid;
    grid.loading = true;
  
    try {
 
     grid.rows = this.retorno;
      //this.$set(grid, 'rows', this.retorno)
    } catch (err) {
      grid.rows = [];
     // this.$set(grid, 'rows', []);
    } finally {
      grid.loading = false;
    }
  }

  
  // [ METHODS ]

}

export default PopUpRetornoEsocial;
